import withAuth from "@/HOCs/withAuth";
import Dashboard from "../Dashboard";

const ReportsAndMetrics = () => {
  return <Dashboard />;
};

export default withAuth(ReportsAndMetrics);
